/**
 * Events API Service (TASK-233 Phase 4)
 *
 * Read-only access to the publishable domain-event registry. Used to populate
 * the `events`-type channel field (a multiselect of available events).
 */
import apiClient from './client';
import type { Event } from '../../types/user';

export const eventsApi = {
  /**
   * List the available publishable events.
   *
   * GET /api/v1/events/ → [{ codename, label }]
   */
  list: async (): Promise<Event[]> => {
    const response = await apiClient.get<Event[]>('/api/v1/events/');
    return response.data;
  },
};

export default eventsApi;
